import Vue from 'vue'
import Vuex from 'vuex'
import baseAPI from '@/http'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isAuthenticated: false,
    loading: false,
    isFullAdmin: false,
    user: {},
    forcedLogout: false,
    token: null,

  },
  mutations: {
    SET_USER(state, payload) {
      state.user = payload
      localStorage.setItem('user', JSON.stringify(payload))
    },
    SET_LOADING(state, payload) {
      state.loading = payload
    },
    SET_FULLADMIN(state, payload) {
      state.isFullAdmin = payload
    },
    LOGOUT: (state) => {
      state.isAuthenticated = false

      delete state.token
      localStorage.removeItem('token')

      delete state.user
      localStorage.removeItem('user')

      delete baseAPI.defaults.headers.common['Authorization']
    },
    SET_FORCED_LOGOUT(state, payload) {
      localStorage.setItem('forcedLogout', payload)
      state.forcedLogout = payload
    },
    SET_TOKEN(state, payload) {
      state.token = payload
      state.isAuthenticated = true
      localStorage.setItem('token', payload)
    },
  },
  actions: {
    setLoading({ commit }, payload) {
      commit('SET_LOADING', payload)
    },
    setFullAdmin({ commit }, payload) {
      commit('SET_FULLADMIN', payload)
    },
    setUser({ commit }, payload) {
      commit('SET_USER', payload)
    },
    logout({ commit }) {
      commit('LOGOUT')
    },
    setForcedLogout({ commit }, payload) {
      commit('SET_FORCED_LOGOUT', payload)
    },
    setToken({ commit }, payload) {
      commit('SET_TOKEN', payload)
    },
  },
  getters: {
    isAuthenticated: state => state.isAuthenticated,
    loading: state => state.loading,
    isFullAdmin: state => state.isFullAdmin,
    user: state => state.user,
    forcedLogout: state => state.forcedLogout,
    token: state => state.token,

  }
});
